<template>
    <div class="alert alert-light border-secondary">

      <span class="close" v-if="$store.state.user.id_usuario == 1" title="Log de Alterações">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="$util.logAudit('atestado', atest.id_atestado)">
          <i class="fas fa-question-circle"></i>
        </a>
      </span>

      <span class="close" v-if="atest.doc_certificado && atest.doc_certificado_link">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(atest)">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </a>
      </span>
      <span class="close" v-if="atest.doc_certificado && atest.doc_certificado_link">
        <a :href="atest.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
          <i class="fas fa-file-contract"></i>
        </a>
      </span>
      <span class="close" v-else-if="atest_pode_assinar(atest)">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar()">
          <i class="fas fa-signature"></i>
        </a>
      </span>
      <span class="close">
        <a href="#" @click.prevent="imprimir_atestado(atest)" class="alert-link mr-1 ml-2">
          <i class="fas fa-print"></i>
        </a>
      </span>
      <span class="close">
        <a class="alert-link mr-1 ml-2" href="#" @click.prevent="editar(atest)" v-if="!view_only">
          <i class="fas fa-street-view"></i>
        </a>
      </span>
      <div>
        <div>
            <a href="#" @click.prevent="toggle_hide(atest)" class="alert-link mr-2" title="Exibição">
                <i class="far fa-minus-square" v-if="!atest.hide"></i>
                <i class="far fa-plus-square" v-else></i>
            </a>
            <template v-if="atest.hide">
              <span >
                Atestado
              </span>
            </template>

            <span v-if="atendimento && atest && atest.id_medico != atendimento.id_medico && atest.medico_edicao" class="text-muted small ml-2">
                {{ atest.medico_edicao.search }}
            </span>
        </div>
      </div>
      <table class="table table-sm mb-0" v-show="!atest.hide">
        <tr v-if="atest.atestado_medico">
          <td width="1%" class="border-0">
            <i class="fa fa-caret-right" aria-hidden="true"></i> 
          </td>
          <td class="border-0">
            Atestado Médico: {{ atest.int_dias_afastamento }} dia(s) <span v-if="atest.cid"> / {{ atest.cid.st_codigo }}</span>
          </td>
        </tr>
        <tr v-if="atest.atestado_comparecimento">
          <td width="1%" class="border-0">
            <i class="fa fa-caret-right" aria-hidden="true"></i> 
          </td>
          <td class="border-0">
            Atestado de Comparecimento: {{ atest.hr_inicio ? atest.hr_inicio.substr(0,5) : "" }} a {{ atest.hr_fim ? atest.hr_fim.substr(0,5) : "" }}
          </td>
        </tr>
        <tr v-if="atest.atestado_acompanhante">
          <td width="1%" class="border-0">
            <i class="fa fa-caret-right" aria-hidden="true"></i> 
          </td>
          <td class="border-0">
            Atestado Acompanhante: {{ atest.st_nome_acompanhante }} <span v-if="atest.int_dias_afastamento">/ {{ atest.int_dias_afastamento }} dia(s)</span>
          </td>
        </tr>
      </table>

      <pre v-if="1 == 0">{{ atest }}</pre>
    </div>
</template>

<script>
export default {
    data () { 
        return { 

        }
    }, 

    props: ['atest', 'atendimento', 'view_only', 'pep'],

    computed: { 
        pode_assinar: function () { 
            return this.atendimento && this.atendimento.medico && this.atendimento.medico.tem_certificado && this.atendimento.medico.id_pessoa == this.$store.state.user.id_pessoa;
        },
    }, 

    methods: { 
        atest_pode_assinar(atest) { 
            if ( !this.atendimento ) { 
                return false;
            }

            let id_medico_atest = atest.id_medico ? atest.id_medico : ( ( this.atendimento && this.atendimento.medico ) ? this.atendimento.medico.id_pessoa : null );

            if ( !id_medico_atest )
                return false;

            let id_medico;
            let medico = this.$store.state.user.medico;

            if ( ( !medico || ( medico && medico.id_pessoa != id_medico_atest ) ) && this.atendimento ) { 
                if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == id_medico_atest) ) { 
                    id_medico = id_medico_atest;
                }
            } else { 
                id_medico = this.$store.state.user.id_pessoa;
            }

            return this.atendimento && id_medico_atest == id_medico; // && this.atendimento.medico.tem_certificado 
        },

        toggle_hide(item) { 
          item.hide = !item.hide;
          this.$forceUpdate();
        },
        imprimir_atestado (atest) { 
          if ( this.pep ) { 
            this.$util.print_preview('imprimir/atestado/' + atest.id_atestado, true, { noass: 1 }, true);  
          } else { 
            this.$util.print_preview('imprimir/atestado/' + atest.id_atestado, true);
          }
        },

        editar (atest) { 

            if ( atest.doc_certificado ) { 
                this.$toast.add({
                severity: "warn",
                summary: "Editar",
                detail: "Documento já assinado. Edição não disponível.",
                life: 3000
                });
            } else { 
                this.$parent.abrir_atestado(atest);
            }
        },
        assinar () { 
            this.$emit('assinar', this.atest);
        },

        cancelar(atest) { 
            if ( !confirm("Confirma cancelar esse registro assinado?") ) 
                return;

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'item_remover', 
                dados: { 
                    model_type: atest.model.type,
                    model_id: atest.model.id,
                },
                    callback: () => { 
                    this.$emit('refresh', null);
                }
            });
            
        },
    }
}
</script>